var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "clock-partition" }, [
    _c(
      "button",
      {
        staticClass: "button action increment",
        attrs: { type: "button" },
        on: {
          click: function ($event) {
            _vm.value++
          },
        },
      },
      [_c("bulma-icon", { attrs: { name: "fas fa-chevron-up" } })],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "control value" }, [
      _c("input", {
        directives: [
          { name: "auto-select-on-focus", rawName: "v-auto-select-on-focus" },
          {
            name: "model",
            rawName: "v-model",
            value: _vm.value,
            expression: "value",
          },
        ],
        staticClass: "input",
        attrs: { type: "number", min: _vm.min, max: _vm.max },
        domProps: { value: _vm.value },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.value = $event.target.value
          },
        },
      }),
    ]),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "button action decrement",
        attrs: { type: "button" },
        on: {
          click: function ($event) {
            _vm.value--
          },
        },
      },
      [_c("bulma-icon", { attrs: { name: "fas fa-chevron-down" } })],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }